import { analyticsUtils } from 'utils/analytics-utils';
import { getPathname } from 'utils/get-pathname';
import { Inputs } from '../pages/project-configuration/types';
import { getGaSubmitDoorProjectElementVariant } from '../pages/project-configuration/forms/interior-doors/helpers/get-ga-submit-door-project-element-variant';

/**
 * Событие срабатывает, когда нажимаешь на кнопку 'Выбрать тип двери' или "Применить" при выборе параметров двери
 */

export const gaSubmitDoorProject = ({
  catalogueLevel,
  buttonText,
  params,
}: {
  catalogueLevel: number;
  buttonText: string;
  params: Inputs;
}) => {
  const path = getPathname();
  const elementVariant = getGaSubmitDoorProjectElementVariant(params);

  return analyticsUtils.sendEvent('GA:clickButton', {
    elementType: 'button',
    elementBlock: `${path}:lvl${catalogueLevel}`, // блок, в котором расположен элемент
    elementName: 'Проекты PLP / Дверь по вашим параметрам',
    elementText: buttonText,
    elementVariant,
  });
};
